var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Страница авторизации")]),_c('br'),_c('router-link',{attrs:{"to":"/signup"}},[_vm._v("Страница регистрации")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }